import React from "react";
import Context from "../../Context";
import BsModal from "./BsModal";

export default class TimePeriodPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      h: ["", ""],
      m: ["", ""],
    };
  }

  componentDidMount() {
    let from = this.props.from?.split(":") || [];
    let to = this.props.to?.split(":") || [];
    this.setState(
      {
        h: [from[0] || "", to[0] || ""],
        m: [from[1] || "", to[1] || ""],
      },
      this.fixTimes
    );
  }

  fixTimes = () => {
    this.setState(({ h, m }) => {
      h = h.map((hour) => {
        hour = hour.replace(/[^0-9]/g, "").substring(0, 2);
        hour = "0".repeat(2 - hour.length) + hour;
        hour = hour > 23 ? "23" : hour;
        hour = hour < 0 ? "00" : hour;
        return hour;
      });
      m = m.map((min) => {
        min = min.replace(/[^0-9]/g, "").substring(0, 2);
        min = "0".repeat(2 - min.length) + min;
        min = min > 59 ? "59" : min;
        min = min < 0 ? "00" : min;
        return min;
      });
      return { h, m };
    });
  };

  valueIncrease = (v, ev) => {
    if (!isNaN(v)) {
      v++;
      if (v > ev) v = 0;
      return v.toString();
    }
    return v;
  };

  valueDecrease = (v, ev) => {
    if (!isNaN(v)) {
      v--;
      if (v < 0) v = ev;
      return v.toString();
    }
    return v;
  };

  onKeyPress = ({ e, hour, minute, index }) => {
    if (e.key === "enter") {
      this.onChange();
      return;
    }

    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
      let value = hour ? this.state.h[index] : this.state.m[index];
      let endValue = hour ? 23 : 59;
      value =
        e.keyCode === 38
          ? this.valueIncrease(value, endValue)
          : this.valueDecrease(value, endValue);

      this.onInputChange({ value, hour, minute, index });
      this.fixTimes();
    }
  };

  onWheel = ({ e, hour, minute, index }) => {
    e.stopPropagation();
    e.preventDefault();
    let value = hour ? this.state.h[index] : this.state.m[index];
    let endValue = hour ? 23 : 59;
    value =
      e.deltaY < 0
        ? this.valueIncrease(value, endValue)
        : this.valueDecrease(value, endValue);

    this.onInputChange({ value, hour, minute, index });
    this.fixTimes();
  };

  onInputChange = ({ value, hour, minute, index }) => {
    this.setState(({ h, m }) => {
      if (hour) h[index] = value;
      if (minute) m[index] = value;
      return { h, m };
    });
  };

  onChange = () => {
    this.fixTimes();
    if (this.props.onChange) {
      const { h, m } = this.state;
      this.props.onChange([[h[0], m[0]].join(":"), [h[1], m[1]].join(":")]);
    }
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { h, m } = this.state;

    const renderInput = ({ value, hour, minute, index }) => {
      const v = hour ? h[index] : m[index];
      return (
        <div>
          <input
            className="form-control text-center font-weight-bold"
            style={{ width: 47 }}
            type="text"
            value={v}
            onBlur={this.fixTimes}
            onWheel={(e) => this.onWheel({ e, hour, minute, index })}
            onClick={(e) => e.target.select()}
            onKeyDown={(e) => this.onKeyPress({ e, hour, minute, index })}
            onChange={(e) =>
              this.onInputChange({ ...e.target, hour, minute, index })
            }
          />
        </div>
      );
    };

    return (
      <BsModal
        show
        sm
        center
        onClose={this.onClose}
        className="time-period-picker"
      >
        {this.props.title && (
          <h6 className="mb-5 text-center">{this.props.title}</h6>
        )}
        <div className="d-flex mb-5 align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div>{renderInput({ hour: true, index: 0 })}</div>
            <div className="mx-1">:</div>
            <div>{renderInput({ minute: true, index: 0 })}</div>
          </div>
          <div className="mx-1"> - </div>
          <div className="d-flex align-items-center">
            <div>{renderInput({ hour: true, index: 1 })}</div>
            <div className="mx-1">:</div>
            <div>{renderInput({ minute: true, index: 1 })}</div>
          </div>
        </div>
        <hr />
        <div className="text-right">
          <input
            type="button"
            onClick={this.onChange}
            className="btn btn-primary mr-2"
            value="OK"
          />
          <input
            type="button"
            onClick={this.onClose}
            className="btn btn-light"
            value="Отмена"
          />
        </div>
      </BsModal>
    );
  }
}
